<div *ngIf="this.proj" class="col m12 iframe da-iframe" [innerHtml]="proj.spirical | safe: 'html'">
</div>


<mat-card class="example-card">
    <mat-card-title-group class="search-proj-card-title">
        <mat-card-title> מבטים ונוף מהקומות הקיימים במערכת</mat-card-title>
    </mat-card-title-group>
    <mat-card-content *ngIf="proj">
        <h3>מבטים</h3>
        <ul>
            <li *ngFor="let direction of directions">

                {{ direction }}
            </li>
        </ul>
        <h3> נוף מהקומות </h3>
        <ul>
            <li *ngFor="let floor of floors">

                {{ floor }}
            </li>
        </ul>

        <h3> נקודה על המפה (קואורדינטות) </h3>
        <span *ngIf="proj.lat === 32 && proj.lng === 34"> הקואורדינטות לא מעודכנות </span>
        <span *ngIf="proj.lat !== 32 && proj.lng !== 34">{{ proj.lat }},{{ proj.lng }}</span>
    </mat-card-content>
</mat-card>


<mat-card class="example-card">
    <mat-card-title-group>
        <mat-card-title> לוגוים </mat-card-title>
    </mat-card-title-group>
    <mat-card-content>
        <h3>לוגו של חברה משותף לכל הפרויקטים</h3>
        <app-gallery (isNoItems)="isNoItems($event, 'comp-logo')" [galleryId]="'1'"
            [section]="compId + 'imagesCompLogo'" [autoPlay]="false" [showThumbs]="false"
            class="logo-img comp-logo"></app-gallery>

        <h3>לוגו פרויקט</h3>
        <app-gallery (isNoItems)="isNoItems($event, 'proj-logo')" [galleryId]="'1'" [section]="projUid+'menuLogo'"
            [autoPlay]="false" [showThumbs]="false" class="logo-img top-project-menu-logo"></app-gallery>

        <h3> מרקר למפה עם לוגו של הפרויקט שמופיע בעמוד מפה </h3>
        <app-gallery (isNoItems)="isNoItems($event, 'proj-marker')" [galleryId]="'1'" [section]="projUid+'imagesMarker'"
            [autoPlay]="false" [showThumbs]="false" class="logo-img"></app-gallery>

        <h3> מרקר למפה עם לוגו של החברה בעמוד מפה במקרים שאין מרקר של פרויקט</h3>
        <app-gallery (isNoItems)="isNoItems($event, 'comp-marker')" [galleryId]="'1'" [section]="compId+'imagesMarker'"
            [autoPlay]="false" [showThumbs]="false" class="logo-img"></app-gallery>
    </mat-card-content>
</mat-card>

<mat-card class="example-card">
    <mat-card-title-group>
        <mat-card-title> מבנים </mat-card-title>
    </mat-card-title-group>
    <mat-card-content>
        <!-- <h3>לוגו של חברה משותף לכל הפרויקטים</h3> -->
        <ul *ngIf="buildList">
            <li *ngFor="let building of buildList">
                <h4>{{ building.name }}</h4>
                <span>
                    <h5>
                        בעל
                        {{ building.floors.length }}
                        קומות
                        בעל
                        {{ building.flatAmount }}
                        דירות
                    </h5>
                </span>
                <button (click)="openItemList(building)">לראות את התוכניות </button>
                <ul *ngIf="building.isItemListOpen">
                    <li *ngFor="let proto of building.prototypes" class="proto-with-flatnumber-image">
                        {{ proto.title }}
                        <app-gallery (isNoItems)="isNoItems($event, 'plan')" [galleryId]="'1'"
                            [section]="proto.list[0].faltPrototypeId+'images'" [autoPlay]="false" [showThumbs]="true"
                            class="list-static"></app-gallery>

                        <ul>
                            <li *ngFor="let flat of proto.list">
                                {{ flat.number }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>

        </ul>

        <ul *ngIf="this.allUsers.length > 1">
            <li *ngFor="let user of this.allUsers">
                {{ user.email }}
                {{ user.displayName }}
            </li>
        </ul>
        <div *ngIf="this.allUsers.length < 1">
            NO USERS
        </div>
        <!-- <app-n-menu-page-with-link [parentId]=projUid></app-n-menu-page-with-link> -->

        <ul class="proj-galleries" *ngIf="this.galleries.length > 0">
            <li *ngFor="let gallery of this.galleries">

                <button (click)="openItemList(gallery)">{{ gallery.LinkName }}</button>

                <app-gallery (isNoItems)="isNoItems($event, 'proj-gal')" *ngIf="gallery.isItemListOpen" @slideRight
                    [galleryId]="'1'" [section]="gallery.id+'images1'" [autoPlay]="false"
                    [showThumbs]="gallery.showThumbs" [resizeDrag]="gallery.resizeDrag"
                    class="{{ gallery.galleryType }}"></app-gallery>
                <app-gallery class="hidden" (isNoItems)="isNoItems($event, 'proj-gal')" @slideRight [galleryId]="'1'"
                    [section]="gallery.id+'images1'" [autoPlay]="false" [showThumbs]="gallery.showThumbs"
                    [resizeDrag]="gallery.resizeDrag" class="{{ gallery.galleryType }}"></app-gallery>
            </li>
        </ul>
        <div *ngIf="this.galleries.length < 1">
            NO GALLERIES
        </div>

        <div class="about-proj-gallery">
            <a *ngIf="isOpenAbout" (click)="isOpenAbout = false" class="pClose"><i class="icon-close"></i></a>
            <button (click)="isOpenAbout = !isOpenAbout">about us</button>
            <app-gallery (isNoItems)="isNoItems($event, 'about-gal')" *ngIf="isOpenAbout" [galleryId]="'1'"
                [section]="projUid + 'about-project'" [autoPlay]="false" [showThumbs]="false"
                class="about-project"></app-gallery>

                <app-gallery (isNoItems)="isNoItems($event, 'about-gal')" [galleryId]="'1'"
                [section]="projUid + 'about-project'" [autoPlay]="false" [showThumbs]="false"
                class="about-project hidden"></app-gallery>
        </div>



        <div class="check-list" *ngIf="proj">
            <ul>
                <li> מבטים <span *ngIf="directions.length > 0">-V</span> </li>
                <li> נוף מהקומות<span *ngIf="floors.length > 0">-V</span> </li>
                <li> נקודה על המפה (קואורדינטות) <span *ngIf="proj.lat !== 32 && proj.lng !== 34">-V</span> </li>
                <li> מבנים <span *ngIf="chekList.buildings">-V</span> </li>
                <li> לוגו חברה<span *ngIf="chekList.compLogo">-V</span> </li>
                <li> לוגו של פרויקט<span *ngIf="chekList.projLogo">-V</span> </li>
                <li> מרקר של פרויקט<span *ngIf="chekList.projMarker">-V</span> </li>
                <li> מרקר של חברה<span *ngIf="chekList.compMarker">-V</span> </li>
                <li> גלריות של פרויקט<span *ngIf="chekList.projGal">-V</span> </li>
                <li> ספר פרויקט<span *ngIf="chekList.aboutGal">-V</span> </li>
                <li class="{{ this.classAlert }}">
                    <div *ngIf="this.proj?.date" [class.alert]="supportPayment"><span *ngIf="supportPayment">נא להסדיר תשלום</span>
                        <div>{{ this.proj.date | date:'dd'}}.{{this.proj.date | date:'MM'}}.{{this.proj.date | date:'yy'}}
                        </div>
                    </div>
                </li>
            </ul>

        </div>

    </mat-card-content>
</mat-card>